import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import RoundedButtonLinkSecondary from '../../../components/button/rounded-button-link-secondary/RoundedButtonLinkSecondary';
import CreateProjectButton from '../../../components/create-project-button/CreateProjectButton';
import { getTotalCollectedAmountByQuery } from '../../../project/project-actions';
import OrganizationCtaCard from './OrganizationCtaCard';
import ButtonActionImportant from '../../../components/button/rounded-button-action/RoundedButtonAction';
import styles from './organization-cta-template-card.module.less';
import { useOrganization } from '../../useOrganization';
import { PRIMARY_ORGANIZATION_COLOR, WHITE_ORGANIZATION_COLOR } from '../../theme/OrganizationTheme';
import { getTemplateCauseImage, TEMPLATE_CAUSE_TYPE } from '../../../template/template-model';

export const OrganizationTemplateCard = ({
    className = '',
    templateId,
    title,
    description,
    img_url,
    birthday,
    dugnad,
    params,
    preview = false,
    customLink,
    customLinkText,
    startProjectText,
    causeId,
    redirectToPreview,
    schoolId,
    causeType,
}) => {
    const { id: organizationId } = useOrganization();

    const createProjectParams =
        params ||
        `?templateId=${templateId}&organizationId=${organizationId}${
            redirectToPreview ? '&redirectToPreview=true' : ''
        }${schoolId ? `&schoolId=${schoolId}` : ''}`;

    const templateImage = useCallback(() => getTemplateCauseImage({ img_url, birthday, dugnad }), [img_url]);

    const [count, setCount] = useState(0);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(
            getTotalCollectedAmountByQuery({
                templateIds: [templateId],
            })
        ).then(({ count }) => {
            setCount(count);
        });
    }, [templateId]);

    const campaignCtaButtons = ({ preview }) => {
        return preview ? (
            <RoundedButtonLinkSecondary
                className={[styles.previewButton, WHITE_ORGANIZATION_COLOR].join(' ')}
                tabindex={'-1'}
            >
                Gå til aksjonssiden
            </RoundedButtonLinkSecondary>
        ) : (
            <RoundedButtonLinkSecondary className={WHITE_ORGANIZATION_COLOR} to={`/cause/${causeId}`}>
                Gå til aksjonssiden
            </RoundedButtonLinkSecondary>
        );
    };

    return (
        <OrganizationCtaCard
            className={className}
            title={title}
            description={description}
            banner={templateImage()}
            projectCount={count}
            customLink={customLink}
            shortenTexts={false}
        >
            <div className={styles.buttons}>
                {customLink ? (
                    <RoundedButtonLinkSecondary to={`${customLink}`}>
                        {customLinkText || 'Les mer'}
                    </RoundedButtonLinkSecondary>
                ) : preview ? (
                    <>
                        <ButtonActionImportant className={styles.previewButton} tabindex="-1">
                            {startProjectText || 'Start en spleis for aksjonen'}
                        </ButtonActionImportant>
                        {campaignCtaButtons({ preview: true })}
                    </>
                ) : (
                    <>
                        <CreateProjectButton
                            category="org-purpose"
                            action="select"
                            properties={{ templateId, organizationId }}
                            linkParams={createProjectParams}
                            className={PRIMARY_ORGANIZATION_COLOR}
                            forceLogin={causeType === TEMPLATE_CAUSE_TYPE.SCHOOL_VGS}
                        >
                            {startProjectText || 'Start en spleis for aksjonen'}
                        </CreateProjectButton>
                        {campaignCtaButtons({ preview: false })}
                    </>
                )}
            </div>
        </OrganizationCtaCard>
    );
};
